import React from 'react';
import { Helmet } from 'react-helmet';

interface IProps {
  title: string;
}

const withHelmet = (Component) => (props: IProps) => {
  const { title, ...rest } = props;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Legwork | {title}</title>
      </Helmet>
      <Component {...rest} />
    </>
  );
};

export default withHelmet;
